import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { softwareProformaIssueFormsDirectRoute } from '@jira/router-routes__proforma-routes/src/softwareProformaIssueFormsDirectRoute.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { proformaIssueFormsDirectPageEntryPoint } from './ui/issue-forms-direct/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareProformaIssueFormsDirectRouteEntry: Route = createEntry(
	softwareProformaIssueFormsDirectRoute,
	() => ({
		group: 'software',
		layout: softwareProjectLayout,
		// eslint-disable-next-line jira/router/no-project-context-resource
		resources: [...jiraSpaResources(), projectContextResource],
		entryPoint: () => proformaIssueFormsDirectPageEntryPoint,

		navigation: {
			menuId: MenuIdProjects,
		},

		perfMetricKey: 'issue-forms-direct',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
